import React from "react";
import { Megaphone } from "lucide-react";

const CampaignEmptyState = ({
    title = "No campaigns found",
    description = "Campaigns will appear here after you create one.",
}) => {
    return (
        <div className="rounded-xl border border-dashed border-gray-300 bg-white px-6 py-10 text-center shadow-sm">
            <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-blue-50 text-blue-600">
                <Megaphone size={22} aria-hidden="true" />
            </div>
            <h2 className="mt-4 text-lg font-semibold text-gray-900">
                {title}
            </h2>
            {description && (
                <p className="mx-auto mt-2 max-w-md text-sm text-gray-500">
                    {description}
                </p>
            )}
        </div>
    );
};

export default CampaignEmptyState;

